import { z } from 'zod';

import { placeOfResidenceBaseSchema } from '@/features/ui';
import { documentDataSchema } from '@/features/ui/DocumentsData/model/schemas';
import { confirmationOfApplicationSchema } from '@/features/ui/Steps/ConfirmationOfApplication/model/schemas';
import { personalAndPassportDataBaseSchema } from '@/features/ui/Steps/PersonalAndPassportData/model/schemas';

import { zodArrayOptional, zodSelectOption, zodStringOptional, zodStringRequired } from '@/shared/lib/validations';

export const transportationAndRouteDataSchema = z.object({
  transportationAndRouteData: z.object({
    vehicleType: zodSelectOption,
    vehicleBrand: zodStringOptional,
    vehicleNumber: zodStringOptional,
    beginningOfRoute: zodStringRequired,
    intermediateRoute: zodArrayOptional(zodStringOptional),
    endOfRoute: zodStringRequired,
    purpose: zodStringRequired,
  }),
});

export const contractSecurityActivitySchema = z.object({
  confirmContractSecurityActivityDoc: zodSelectOption,
  contractSecurityActivity: documentDataSchema.nullish(),
});

export const coldSteelTransportationMergedSchema = transportationAndRouteDataSchema
  .merge(personalAndPassportDataBaseSchema)
  .merge(placeOfResidenceBaseSchema)
  .merge(contractSecurityActivitySchema)
  .merge(confirmationOfApplicationSchema);
